import React, { Suspense, useEffect, useRef, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";
import styled from "styled-components";

const EarthWrap = styled.div`
  width: min(100%, 460px);
  height: 320px;
`;

const Earth = () => {
  const earth = useGLTF("./planet/scene.gltf");
  return (
    <primitive object={earth.scene} scale={2.6} position-y={0} rotation-y={0} />
  );
};

const EarthCanvas = () => {
  const wrapRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = wrapRef.current;
    if (!node) return;

    const update = (onScreen) => {
      setVisible(onScreen && !document.hidden);
    };
    const observer = new IntersectionObserver(
      ([entry]) => update(entry.isIntersecting),
      { rootMargin: "160px" }
    );
    observer.observe(node);
    const onVisibility = () => {
      if (document.hidden) {
        setVisible(false);
        return;
      }
      const rect = node.getBoundingClientRect();
      update(rect.bottom > -160 && rect.top < window.innerHeight + 160);
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  return (
    <EarthWrap ref={wrapRef}>
      {visible && (
        <Canvas
          frameloop="always"
          dpr={1}
          gl={{ antialias: false, powerPreference: "high-performance" }}
          camera={{
            fov: 45,
            near: 0.1,
            far: 200,
            position: [-4, 3, 6],
          }}
        >
          <Suspense fallback={null}>
            <OrbitControls
              autoRotate
              autoRotateSpeed={0.6}
              enableZoom={false}
              enablePan={false}
              maxPolarAngle={Math.PI / 2}
              minPolarAngle={Math.PI / 2}
            />
            <Earth />
          </Suspense>
        </Canvas>
      )}
    </EarthWrap>
  );
};

export default EarthCanvas;
